import { SliderAction } from '../../tool/action/slider-action';

export class SliderActionBuilder {
  readonly _sliderAction: SliderAction;

  constructor(
    name: string,
    icon: string,
    min: number,
    max: number,
    step = 1,
    value?: number,
  ) {
    this._sliderAction = SliderAction.create(name, icon, min, max, step, value);
    return this;
  }

  public setText(text: string): SliderActionBuilder {
    this._sliderAction.text = text;
    return this;
  }

  public setTooltip(tooltip: string): SliderActionBuilder {
    this._sliderAction.tooltip = tooltip;
    return this;
  }

  public enable(): SliderActionBuilder {
    this._sliderAction.enable = true;
    return this;
  }

  public disable(): SliderActionBuilder {
    this._sliderAction.enable = false;
    return this;
  }

  public setValue(value: number): SliderActionBuilder {
    this._sliderAction.value = value;
    return this;
  }

  public showText(): SliderActionBuilder {
    this._sliderAction.showText = true;
    return this;
  }

  public hideText(): SliderActionBuilder {
    this._sliderAction.showText = false;
    return this;
  }

  public showLegend(): SliderActionBuilder {
    this._sliderAction.showLegend = true;
    return this;
  }

  public hideLegend(): SliderActionBuilder {
    this._sliderAction.showLegend = false;
    return this;
  }

  public setNbToDisplay(nbToDisplay: number): SliderActionBuilder {
    this._sliderAction.nbToDisplay = nbToDisplay;
    return this;
  }

  public setAlign(align: 'left' | 'center' | 'right') {
    this._sliderAction.align = align;
    return this;
  }

  public setStorageKey(storageKey: string): SliderActionBuilder {
    this._sliderAction.storageKey = storageKey;
    return this;
  }

  public build(): SliderAction {
    return this._sliderAction;
  }
}
